<template>
    <div class="relative max-w-[300px]">
        <p v-if="title" class="font-bold" :class="enable ? 'text-black' : 'text-gray-400'">
            {{ title }}
        </p>
        <div>
            <input
                type="text"
                :name="inputName"
                class="form-input border rounded-2xl w-full selected:border-blue-800 border-gray-500 disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300"
                autocomplete="off"
                v-model="state"
                @input="filterStates"
                @focus="modal = true"
                :placeholder="placeholder"
            />
            <div class="cursor-pointer absolute flex justify-center items-center right-0 -translate-y-full h-[42px] w-[42px] border-l-0">
                <Icon v-if="state" @click="clear()" class="cursor-pointer" name="Fechar" />
                <Icon v-else name="Pesquisar"/>
            </div>
            <div v-if="computedParticipants.length && modal">
                <ul
                    class="mt-2 p-0 m-0 overflow-auto border border-gray-300 rounded-2xl border-b-0 max-h-[220px] noscroll"
                >
                    <li
                        v-for="filteredState in computedParticipants"
                        class="break-words cursor-pointer hover:bg-[#2E59FF] hover:text-white text-black form-input w-full border-b selected:border-blue-800 disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300 border-gray-300"
                        :key="filteredState.id"
                        @click="setState(filteredState)"
                    >
                        {{ filteredState.name }} {{ filteredState.codeSap }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";

export default {
    components: {
        Icon,
    },
    props: {
        title: String,
        participants: Object,
        state: String,
        initialValue: String,
        inputName: String,
        enable: String,
        placeholder: String,
    },
    emits: ["updateValue"],
    data() {
        return {
            states: this.participants?.map(({ name, codeSap, id }) => ({
                name,
                codeSap,
                id,
            })),
            state: this.initialValue,
            modal: false,
            filteredStates: [],
            initialValue: String,
        };
    },
    mounted() {
        this.filterStates();
    },
    methods: {
        filterStates() {
            if (this.state?.length == 0) {
                this.filteredStates = this.state;
            }

            this.filteredStates = this.states.filter((state) => {
                let merge = `${state.name.toLowerCase()} ${state.codeSap}`;
                return merge.search(this.state?.toLowerCase()) != -1;
            });
        },
        setState(state) {
            this.state = state.name;

            this.$emit("updateValue", state);
            this.modal = false;
        },
        clear() {
            this.state = '',
            this.$emit("updateValue", {id: ''});
        }
    },

    watch: {
        state() {
            this.filterStates();
        },
        participants: {
            handle(newValue) {
                console.log('vem valor');
                this.states = newValue?.map(({ name, codeSap, id }) => ({
                    name,
                    codeSap,
                    id,
                }))
            },
            deep: true,
        }
    },

    computed: {
        computedParticipants: function () {
            const formattedParticipants = this.participants.map(({ name, codeSap, id }) => ({
                name,
                codeSap,
                id,
            }));

            if(this.state) {
                return formattedParticipants.filter(participant => {
                    let merge = `${participant.name.toLowerCase()} ${participant.codeSap}`;
                    return merge.search(this.state?.toLowerCase()) != -1;
                })
            } else {
                return formattedParticipants;
            }
        },
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
